import { render, staticRenderFns } from "./choose-one-sheffield.vue?vue&type=template&id=5aecbb98&"
import script from "./choose-one-sheffield.vue?vue&type=script&lang=js&"
export * from "./choose-one-sheffield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports